// extracted by mini-css-extract-plugin
export default {"bottom_sheet":"PaymentCardsList_bottom_sheet__IEf6R"};